import { render } from "./IdenticalFormulationItemAppModal.vue?vue&type=template&id=202da73a"
import script from "./IdenticalFormulationItemAppModal.vue?vue&type=script&setup=true&lang=js"
export * from "./IdenticalFormulationItemAppModal.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/codebuild/output/src3003388635/src/git-codecommit.ap-northeast-1.amazonaws.com/v1/repos/portal-dev-frontend/vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/components/parts/modal/IdenticalFormulationItemAppModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "202da73a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('202da73a', __exports__)) {
    console.log('reload')
    api.reload('202da73a', __exports__)
  }
  
  module.hot.accept("./IdenticalFormulationItemAppModal.vue?vue&type=template&id=202da73a", () => {
    console.log('re-render')
    api.rerender('202da73a', render)
  })

}


export default __exports__